import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreatePricingPlanTier } from 'src/features/pricingPlan/api/tiers/useCreatePricingPlanTier';
import { LIST_PRICING_PLAN_TIERS_RESOURCE } from 'src/features/pricingPlan/api/tiers/useListPricingPlanTiers';
import TierFormModal from 'src/features/pricingPlan/components/form/tiers/TierFormModal';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { useParking } from 'src/providers/ParkingProvider';

interface TierFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateTierFormModal<TData>({ className, semantics }: TierFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { planId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreatePricingPlanTier({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PRICING_PLAN_TIERS_RESOURCE] });
            toast({
                title: formatMessage(pricingPlanMessages.createTierSuccess),
                description: formatMessage(pricingPlanMessages.createTierSuccessDescription),
            });
        },
    });

    return (
        <TierFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ planId, parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(pricingPlanMessages.addTierSubtitle)}
        />
    );
}

export default CreateTierFormModal;
